type IDeviceRegAndWidth = Array<{
    reg: RegExp;
    width: number;
}>;

const deviceRegAndWidth: IDeviceRegAndWidth = [
    // pad
    {
        reg: /ipad/i,
        width: 768,
    },
    // 移动端
    {
        // eslint-disable-next-line max-len
        reg: /(iOS|nokia|iphone|android|motorola|^mot\\-|softbank|foma|docomo|kddi|up\.browser|up\.link|htc|dopod|blazer|netfront|helio|hosin|huawei|novarra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam\\-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte\\-|longcos|pantech|gionee|^sie\\-|portalmmm|jig\s browser|hiptop|^ucweb|^benq|haier|^lct|opera\s*mobi|opera\*mini|320x320|240x320|176x220)/i,
        width: 414,
    },
    // pc端
    {
        reg: /\\/i,
        width: 1920,
    },
];
const getWidthByUA = (userAgent?: string): number => {
    if (userAgent) {
        const ua = userAgent.toLocaleLowerCase();
        for (const device of deviceRegAndWidth) {
            if (device.reg.test(ua)) {
                return device.width;
            }
        }
    }
    // 默认返回pc
    return deviceRegAndWidth[2].width;
};

export default getWidthByUA;
